
import { useParams } from "react-router-dom";
import axios from 'axios';

import SpinningWheelWorkflow from '../workflows/spinningWheelWorkflow';

// ----------------------------------------------------------------------


export default function SpinningWheelWinWizard(props) {



  let params = useParams();






 return (
  <>
        <SpinningWheelWorkflow snippetId={params.snippetId} />

  </>
);
}
